import { ReactComponent as IconArrow } from "@common_assets/svg/arrowBack.svg"
import { Box, Button, Zoom, useScrollTrigger } from "@mui/material"
import { useTranslation } from "react-i18next"
import { scrollToTop } from "utils/scroll"

const BackToTop = () => {
  const { t } = useTranslation()
  const scrolled = useScrollTrigger({ disableHysteresis: true, threshold: 200 })

  const handleClick = () => {
    scrollToTop()
    // Keyboard users land back at the start of the content, not on a button
    // that is about to disappear.
    document.getElementById("main-content")?.focus({ preventScroll: true })
  }

  return (
    <Zoom in={scrolled} unmountOnExit>
      <Button
        variant="contained"
        endIcon={
          <Box
            component={IconArrow}
            aria-hidden
            sx={{ transform: "rotate(90deg)" }}
          />
        }
        onClick={handleClick}
        sx={{
          position: "fixed",
          right: { mobile: 16, tablet: 24 },
          bottom: { mobile: 16, tablet: 24 },
          zIndex: "speedDial",
        }}
      >
        {t("adminDashboard.backToTop")}
      </Button>
    </Zoom>
  )
}

export default BackToTop
